import regionSlices from './region.slice';
export default regionSlices;